import React, { useState } from "react";
import styled from "styled-components";

type Props = {
  initialValue: string | undefined;
  name?: string | undefined;
  disabled: boolean;
  required?: boolean | undefined;
};

export const DateInput: React.FC<Props> = ({
  initialValue,
  disabled,
  required,
  name
}) => {
  const [value, setValue] = useState(initialValue);

  const toInputDate = (val: string | undefined) => {
    if(!val || val.length !== 8) return "";
    return `${val.slice(0, 4)}-${val.slice(4,6)}-${val.slice(6,8)}`
  }
  
  return (
    <StyledDiv>
      <StyledInput
        type="date"
        value={toInputDate(value)}
        max={"9999-12-31"}
        required={required}
        onChange={(e) => {
          setValue(e.target.value.replaceAll("-", ""));
        }}
        disabled={disabled}
      />
      <input
        type="hidden"
        name={name}
        value={value}>
      </input>
    </StyledDiv>
)};

const StyledDiv = styled.div`
  border: 1px solid lightgray;
  padding: 1px;
  transition: none;
  white-space: pre-wrap;
`;
const StyledInput = styled.input`
  width: 97%;
  border-radius: 7px;
  text-align: left;
  height: 40px;
  border: 1px solid lightgray;
  font-family: "Source Sans Pro", YuGothic, "Yu Gothic", Meiryo, メイリオ, "Hiragino Kaku Gothic ProN W3", "ヒラギノ角ゴ ProN W3", sans-serif;
  font-size: 13px;
  padding-left: 20px;
  padding-right: 9px;
`;
